import { render, staticRenderFns } from "./DepartmentPermissionRow.vue?vue&type=template&id=ee3e6ebe&scoped=true"
import script from "./DepartmentPermissionRow.vue?vue&type=script&lang=js"
export * from "./DepartmentPermissionRow.vue?vue&type=script&lang=js"
import style0 from "./DepartmentPermissionRow.vue?vue&type=style&index=0&id=ee3e6ebe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3e6ebe",
  null
  
)

export default component.exports